module.exports = __webpack_public_path__ + "img/pa.d116f711.svg";